import * as components from './components'
import * as hooks from './hooks'

console.log('Domains feature initialized!')

export { components, hooks }
